import React, { Component } from 'react'
import '../styles/ClusterCommitments.css'
import AlertMessage from '../widgets/AlertMessage'
import ActivityIndicator from '../widgets/ActivityIndicator'
import OrgFooter from '../widgets/OrgFooter'
import APIClusterRequest from '../api/APIClusterRequest'
import APISupplyPlanRequest from '../api/APISupplyPlanRequest'

class CollectiveMarketing extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			user: JSON.parse(sessionStorage.getItem("user")),
			clusterId: sessionStorage.getItem("cluster-id"),
			targetCropId: props.targetCropId,
			spid: props.spid,
			listItems: [],
			farmers: {},
			updatedDetails: {},
			deliveryDate: props.deliveryData?.delivery_date,
			deliveryId: props.deliveryData?.delivery_id,
			totalVolumeCommitted: props.deliveryData?.totalVolumeCommitted,
			volumeSold: props.deliveryData?.totalVolumeSold,
			ciid: props.ciid
		}
		this.setTableValues = this.setTableValues.bind(this)
		this.handleFooterEvent = this.handleFooterEvent.bind(this)
		this.getProductDeliveryById = this.getProductDeliveryById.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
		this.itemEventHandler = this.itemEventHandler.bind(this)
		// this.addProductDelivery = this.addProductDelivery.bind(this)
		this.addDeliveryDetailsByClusterInvolvelemtnId = this.addDeliveryDetailsByClusterInvolvelemtnId.bind(this)
		this.editDeliveryDetailsByClusterInvolvelemtnId = this.editDeliveryDetailsByClusterInvolvelemtnId.bind(this)
		// this.editProductDelivery = this.editProductDelivery.bind(this)
		this.getDeliveryDetailsByClusterInvolvementId = this.getDeliveryDetailsByClusterInvolvementId.bind(this)
	}

	onSubmit() {
		const deliveryDetails = []
		const addDeliveryDetails = []
		Object.values(this.state.updatedDetails).forEach((v => {
			if(v.delivery_detail_id == null) {
				addDeliveryDetails.push(v)
			}
			else {
				deliveryDetails.push(v)
			}
		}))
		const data = {}
		if(this.state.deliveryDetails?.length < this.state.members.length || this.state.deliveryDetails == null) {
			const uds = Object.keys(this.state.updatedDetails)
			this.state.members.map((item, i) => {
				if(!uds.includes(item.farmer_id.toString())) {
					addDeliveryDetails.push({
						farmer_id: item.farmer_id,
						supply_delivered: 0,
						trader_offered_price: 0
					})
				}
			})
		}
		if(deliveryDetails.length > 0) {
			data["deliveryDetail"] = deliveryDetails
			if(addDeliveryDetails.length > 0) {
				data["add"] = {}
				data["add"]["deliveryDetail"] = addDeliveryDetails
			}
		}
		else {
			data["deliveryDetail"] = addDeliveryDetails
		}
		let isRequired = false
		if(data.deliveryDetail) {
			data.deliveryDetail.map((item, i) => {
				if(item.supply_delivered && item.supply_delivered != 0) {
					if(item.unit_production_cost == null || item.unit_production_cost == 0) {
						isRequired = true
						this.setState({
							showInfoMessage: true,
							aMessage: "Production Cost per Kilo is required",
							showActivityIndicator: false
						})
						return
					}
				}
				if(item.supply_delivered > 0 && item.trader_offered_price == 0) {
					isRequired = true
					this.setState({
						showInfoMessage: true,
						aMessage: "Trader's Offered Price is required",
						showActivityIndicator: false
					})
					return
				}
			})
		}
		if(data.add) {
			data.add.deliveryDetail.map((item, i) => {
				if(item.supply_delivered && item.supply_delivered != 0) {
					if(item.unit_production_cost == null || item.unit_production_cost == 0) {
						isRequired = true
						this.setState({
							showInfoMessage: true,
							aMessage: "Production Cost per Kilo is required",
							showActivityIndicator: false
						})
						return
					}
				}
				if(item.supply_delivered > 0 && item.trader_offered_price == 0) {
					isRequired = true
					this.setState({
						showInfoMessage: true,
						aMessage: "Trader's Offered Price is required",
						showActivityIndicator: false
					})
					return
				}
			})
		}
		if(isRequired) {
			return
		}
		let totalVS = 0
		Object.values(this.state.volumeSoldPerFarmer).map((item, i) => {
			totalVS += item
		})
		if(this.state.volumeSold == null) {
			this.state.volumeSold = {}
		}
		this.state.volumeSold[this.state.deliveryId] = totalVS
		let totalVolumeSold = 0
		Object.values(this.state.volumeSold).map((item, i) => {
			totalVolumeSold += item
		})
		if(totalVolumeSold < this.state.totalVolumeCommitted) {
			this.setState({
				showConfirmMessage: true,
				aMessage: "The Total Volume Sold is not equal to the Total Volume Committed. Do you want to continue saving the data?",
				data: data
			})
			return
		}
		if(deliveryDetails.length > 0) {
			this.editDeliveryDetailsByClusterInvolvelemtnId(data)
		}
		else {
			this.addDeliveryDetailsByClusterInvolvelemtnId(data)
		}
	}

	addDeliveryDetailsByClusterInvolvelemtnId(data) {
		const apiReq = APISupplyPlanRequest.addDeliveryDetailsByClusterInvolvelemtnId(this.state.accessToken, data, this.state.ciid)
		apiReq.then((response) => {
			if(response.status !== "SUCCESS") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			this.getDeliveryDetailsByClusterInvolvementId((members) => {
				this.getClusterById(members)
			})	
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + response.description,
				showActivityIndicator: false,
				close: true
			})
		})
	}

	editDeliveryDetailsByClusterInvolvelemtnId(data) {
		const apiReq = APISupplyPlanRequest.editDeliveryDetailsByClusterInvolvelemtnId(this.state.accessToken, data, this.state.ciid)
		apiReq.then((response) => {
			if(response.status !== "SUCCESS") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			this.getDeliveryDetailsByClusterInvolvementId((members) => {
				this.getClusterById(members)
			})	
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + response.description,
				showActivityIndicator: false,
				close: true
			})
		})
	}

	editProductDelivery(data) {
		const apiReq = APISupplyPlanRequest.editProductDeliveryById(this.state.accessToken, data, this.state.ciid)
		apiReq.then((response) => {
			if(response.status !== "SUCCESS") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			this.getTargetCropById((members) => {
				this.getProductDeliveryById(members)
			})
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + response.description,
				showActivityIndicator: false
			})
		})
	}

	componentWillMount() {
		this.getDeliveryDetailsByClusterInvolvementId((members) => {
			this.getClusterById(members)
		})
	}

	getDeliveryDetailsByClusterInvolvementId(callback) {
		this.setState({showActivityIndicator: true})
		const apiReq = APISupplyPlanRequest.getDeliveryDetailsByClusterInvolvementId(this.state.accessToken, this.state.ciid)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				callback()
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			const m = {}
			for(const v of response.results.rows) {
				m[v.farmer_id] = v
			}
			callback(m)
		})
	}

	getTargetCropById(callback) {
		this.setState({showActivityIndicator: true})
		const cluster = APIClusterRequest.getTargetCropById(this.state.accessToken, this.state.targetCropId)
		cluster.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			const m = {}
			for(const v of response.results.initialCommitment) {
				m[v.farmer_id] = v
			}
			callback(m)
			this.setState({
				members: response.results.members,
				showActivityIndicator: false
			})
		})
	}

	getProductDeliveryById(members, id) {
		const apiReq = APISupplyPlanRequest.getProductDeliveryById(this.state.accessToken, this.state.deliveryId)
		apiReq.then((response) => {
			if(response.status !== "SUCCESS") {
				this.getClusterById(true)
				return
			}
			if(response.results.deliveryDetail.length == 0) {
				this.getClusterById(true)
				return
			}
			this.getClusterById()
			this.setTableValues(response.results.deliveryDetail)
			this.setState({
				showActivityIndicator: false,
				deliveryDetails: response.results.deliveryDetail
			})
		})
	}

	getClusterById(members) {
		const cluster = APIClusterRequest.getClusterById(this.state.accessToken, this.state.clusterId)
		cluster.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			const keys = Object.keys(members? members : {})
			const m = []
			response.results.members.map((item, i) => {
				if(keys.includes(item.farmer_id.toString())) {
					m.push(members[item.farmer_id.toString()])
				}
				else {
					m.push(item)
				}
			})
			this.setTableValues(m)
			this.setState({
				members: response.results.members,
			})
		})
	}

	setTableValues(members) {
		members.sort((a, b) => {
			return(a.first_name.localeCompare(b.first_name))
		})
		const listItems = []
		let volumeSoldPerFarmer = {}
		for(const m of members) {
			volumeSoldPerFarmer[m.farmer_id] = m.supply_delivered
			listItems.push(<ListItem data={m} handler={this.itemEventHandler}
				spid={this.state.spid} disabled={this.state.disabled} key={Math.random()} />)
		}
		this.setState({
			listItems: listItems,
			volumeSoldPerFarmer: volumeSoldPerFarmer,
			showActivityIndicator: false
		})
	}

	itemEventHandler(farmerId, value) {
		this.state.volumeSoldPerFarmer[farmerId] = parseInt(value.supply_delivered)
		this.state.updatedDetails[farmerId] = value
	}

	handleFooterEvent(e) {
		this.props.setView("update", this.state.clusterId, null, this.state.spid)
	}

	render() {
		const view = <div className="cluster-commitments">
			<div id="cc-scroll-area"><div id="cc-client-area">
				<div id="cc-table">
					<div className="cc-reg-no">Farmer Registration Number</div>
					<div className="cc-name">Farmer Full Name</div>
					<div className="cc-step2-area">* Volume Sold</div>
					<div className="cc-step2-commitment">* Price per Unit</div>
					<div className="cc-step4">Gross Sales</div>
					<div className="cc-step6">* Production Cost per Kilo</div>
					<div className="cc-step4">Production Cost</div>
					<div className="cc-step4">Post-hastvest Cost per Kilo</div>
					<div className="cc-step4">Post-harvest Cost</div>
					<div className="cc-step4">Gross Profit</div>
					<div className="cc-step4">Marketing Cost per Kilo</div>
					<div className="cc-step4">Marketing Cost</div>
					<div className="cc-step4">Net Income</div>
					<div className="cc-step4">* Trader's Offered/Local Market Price</div>
					<div className="cc-step4">Remarks/Notes</div>
				</div>
				{this.state.listItems}
			</div>
			</div>
			<div className="alternate-footer">
				<OrgFooter submit={this.onSubmit} eventHandler={this.handleFooterEvent}
					showClose={!this.state.disabled}
					showSubmit={(this.state.user.role_id == 3)? !this.state.disabled: false}
					showUpdate={this.state.disabled}/>
			</div>
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => {
					this.setState({showInfoMessage: false})
					if(this.state.close) {
						this.handleFooterEvent()
					}
				}} />}
				{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
				{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
				onClick={(e) => {
					if(e.target.innerHTML === 'YES') {
						this.editDeliveryDetailsByClusterInvolvelemtnId(this.state.data)
						{/* this.editProductDelivery(this.state.data) */}
					}
					this.setState({showConfirmMessage: false})
				}} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class ListItem extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			isOn: false,
			evaluatedSupply: "0",
			member: props.data,
			deliveryDetail: {},
			disabled: (props.disabled == null)? true: props.disabled
		}
	}

	componentWillMount() {
		if(this.state.member != null) {
			this.state.deliveryDetail['farmer_id'] = this.state.member.farmer_id
			if(this.state.member.delivery_detail_id != null) {
				this.state.deliveryDetail['delivery_detail_id'] = this.state.member.delivery_detail_id
				this.state.deliveryDetail["trader_offered_price"] = this.state.member.trader_offered_price
				this.state.deliveryDetail["supply_delivered"] = this.state.member.supply_delivered
				this.state.deliveryDetail["price_per_unit"] = this.state.member.price_per_unit
				this.state.deliveryDetail["unit_production_cost"] = this.state.member.unit_production_cost
				this.state.deliveryDetail["unit_marketing_cost"] = this.state.member.unit_marketing_cost
				this.state.deliveryDetail["unit_post_harvest_cost"] = this.state.member.unit_post_harvest_cost
			}
			let mi = ''
			if(this.state.member.middle_name != null) {
				mi = this.state.member.middle_name.charAt(0) + "."
			}
			const extn = (this.state.member.extension_name != null)? this.state.member.extension_name: ""
			const name = this.state.member.first_name + " " + mi + " " + this.state.member.last_name + " " + extn
			this.state.member["farmer_id"] = this.state.member.farmer_id
			const vs = (this.state.member.supply_delivered == null)? 0: this.state.member.supply_delivered
			const ppu = (this.state.member.price_per_unit == null)? 0: this.state.member.price_per_unit
			const upc =  (this.state.member.unit_production_cost == null)? 0: this.state.member.unit_production_cost
			const uphc = (this.state.member.unit_post_harvest_cost == null)? 0: this.state.member.unit_post_harvest_cost
			const mcpk =  (this.state.member.unit_marketing_cost == null)? 0: this.state.member.unit_marketing_cost
			const top =  (this.state.member.trader_offered_price == null)? 0: this.state.member.trader_offered_price
			const gs = vs * ppu
			const pc = vs * upc
			const phc = vs * uphc
			const gp = gs - pc - phc
			const mc = vs - mcpk
			const ni = gp - mc
			this.setState({
				regNum: this.state.member.registration_no,
				name: name.toUpperCase(),
				farmerId: this.state.member.farmer_id,
				volumeSold: (this.state.member.supply_delivered == 0)? null: this.state.member.supply_delivered,
				pricePerUnit: formatCurrency(this.state.member.price_per_unit),
				grossSales: formatCurrency(gs),
				pcpk: formatCurrency(this.state.member.unit_production_cost),
				productionCost: formatCurrency(pc),
				phcpk: formatCurrency(this.state.member.unit_post_harvest_cost),
				postHarvestCost: formatCurrency(phc),
				grossProfit: formatCurrency(gp),
				mcpk: formatCurrency(this.state.member.unit_marketing_cost),
				marketingCost: formatCurrency(mc),
				netIncome: formatCurrency(ni),
				tradersPrice: formatCurrency(this.state.member.trader_offered_price),
				remarks: this.state.member.remarks
			})
		}
	}

	render() {
		const view = <div className="cm-listItem">
			<div className="cc-reg-no li-reg-no" disabled={this.state.disabled}>{this.state.regNum}</div>
			<div className="cc-name li-name" disabled={this.state.disabled}>{this.state.name}</div>
			<div className="cc-step2-area cm-volume">
				<input type="text" value={this.state.volumeSold} placeholder='0' onChange={(e) => {
					const checker = /^[\d,]+\.?\d{0,2}?$/
					const isValid = checker.test(e.target.value)
					if(isValid) {
						this.state.deliveryDetail["supply_delivered"] = e.target.value
						this.props.handler(this.state.farmerId, this.state.deliveryDetail)
						const gs = parseInt(e.target.value) * ((this.state.pricePerUnit == null)? 0: parseFloat(this.state.pricePerUnit))
						const pc = parseFloat(e.target.value) * ((this.state.pcpk == null)? 0: parseFloat(this.state.pcpk))
						if(isNaN(pc)) {
							pc = 0.00
						}
						let phc = parseFloat(e.target.value) * ((this.state.phcpk == null)? 0: parseFloat(this.state.phcpk))
						if(isNaN(phc)) {
							phc = 0.00
						}
						let mc = parseFloat(e.target.value) * ((this.state.mcpk == null)? 0: parseFloat(this.state.mcpk))
						if(isNaN(phc)) {
							mc = 0.00
						}
						const gp = gs - pc - phc
						const ni = gp - mc
						this.setState({
							volumeSold: e.target.value,
							grossSales: formatCurrency(gs),
							productionCost: formatCurrency(pc),
							postHarvestCost: formatCurrency(phc),
							marketingCost: formatCurrency(mc),
							grossProfit: formatCurrency(gp),
							netIncome: formatCurrency(ni),
						})
					}
					else {
						if(isNaN(parseInt(e.target.value))) {
							this.setState({volumeSold: null})
							e.target.value = ""
						}
						else {
							e.target.value = parseInt(e.target.value);
						}
					}
				}} />
			</div>
			<div className="cc-step2-commitment cm-ppu">
				<input type="text" value={this.state.pricePerUnit} placeholder='0.00' onChange={(e) => {
					const checker = /^[\d,]+\.?\d{0,2}?$/
					const isValid = checker.test(e.target.value);
					if(isValid) {
						this.state.deliveryDetail["price_per_unit"] = e.target.value
						this.props.handler(this.state.farmerId, this.state.deliveryDetail)
						let gs = parseInt(this.state.volumeSold) * parseFloat(e.target.value)
						if(isNaN(gs)) {
							gs = 0.00
						}
						let pc = this.state.productCost?.replace(/,/g, "")
						if(isNaN(pc)) {
							pc = 0.00
						}
						let phc = this.state.postHarvestCost?.replace(/,/g, "")
						if(isNaN(phc)) {
							phc = 0.00
						}
						let mc = this.state.marketingCost?.replace(/,/g, "")
						if(isNaN(mc)) {
							mc = 0.00
						}
						const gp = gs - pc - phc
						const ni = gp - mc
						this.setState({
							grossSales: formatCurrency(gs),
							pricePerUnit: e.target.value,
							grossProfit: formatCurrency(gp),
							netIncome: formatCurrency(ni)
						})
					}
					else {
						if(isNaN(parseInt(e.target.value))) {
							this.setState({pricePerUnit: null})
							e.target.value = ""
						}
						else {
							e.target.value = parseInt(e.target.value);
						}
					}
				}} />
			</div>
			<div className="cc-step4 cm-gross">
				<input type="text" value={this.state.grossSales} placeholder='0.00' disabled={this.state.disabled} />
			</div>
			<div className="cc-step6 cm-pcpk">
				<input type="text" value={this.state.pcpk} placeholder='0.00' onChange={(e) => {
					const checker = /^[\d,]+\.?\d{0,2}?$/
					const isValid = checker.test(e.target.value);
					if(isValid) {
						this.state.deliveryDetail["unit_production_cost"] = e.target.value
						this.props.handler(this.state.farmerId, this.state.deliveryDetail)
						let pc = parseInt(this.state.volumeSold) * parseFloat(e.target.value)
						if(isNaN(pc)) {
							pc = 0.00
						}
						let gs = this.state.grossSales?.replace(/,/g, "")
						if(isNaN(gs) || gs == null) {
							gs = 0.00
						}
						let phc = this.state.postHarvestCost?.replace(/,/g, "")
						if(isNaN(phc) || phc == null) {
							phc = 0.00
						}
						let mc = this.state.marketingCost?.replace(/,/g, "")
						if(isNaN(mc) || mc == null) {
							mc = 0.00
						}
						const gp = gs - pc - phc
						const ni = gp - mc
						this.setState({
							pcpk: e.target.value,
							productionCost: formatCurrency(pc),
							grossProfit: formatCurrency(gp),
							netIncome: formatCurrency(ni)
						})
					}
					else {
						if(isNaN(parseInt(e.target.value))) {
							this.setState({pcpk: null})
							e.target.value = ""
						}
						else {
							e.target.value = parseInt(e.target.value);
						}
					}
				}} />
			</div>
			<div className="cm-production-cost">
				<input type="text" value={this.state.productionCost} placeholder='0.00' disabled={this.state.disabled} />
			</div>
			<div className="cm-phcpk">
				<input type="text" value={this.state.phcpk} placeholder='0.00' onChange={(e) => {
					const checker = /^[\d,]+\.?\d{0,2}?$/
					const isValid = checker.test(e.target.value);
					if(isValid) {
						this.state.deliveryDetail["unit_post_harvest_cost"] = e.target.value
						this.props.handler(this.state.farmerId, this.state.deliveryDetail)
						let phc = parseInt(this.state.volumeSold) * parseFloat(e.target.value)
						if(isNaN(phc)) {
							phc = 0.00
						}
						let pc = this.state.productionCost?.replace(/,/g, "")
						if(isNaN(pc)) {
							pc = 0.00
						}
						let gs = this.state.grossSales?.replace(/,/g, "")
						if(isNaN(gs)) {
							gs = 0.00
						}
						let mc = this.state.marketingCost?.replace(/,/g, "")
						if(isNaN(mc)) {
							mc = 0.00
						}
						const gp = gs - pc - phc
						const ni = gp - mc
						this.setState({
							phcpk: e.target.value,
							postHarvestCost: formatCurrency(phc),
							grossProfit: formatCurrency(gp),
							netIncome: formatCurrency(ni)
						})
					}
					else {
						if(isNaN(parseInt(e.target.value))) {
							this.setState({phcpk: null})
							e.target.value = ""
						}
						else {
							e.target.value = parseInt(e.target.value);
						}
					}
				}} />
			</div>
			<div className="cm-harvest-cost">
				<input type="text" value={this.state.postHarvestCost} placeholder='0.00' disabled={this.state.disabled} />
			</div>
			<div className="cm-gross-profit">
				<input type="text" value={this.state.grossProfit} placeholder='0.00' disabled={this.state.disabled} />
			</div>
			<div className="cm-mcpk">
				<input type="text" value={this.state.mcpk} placeholder='0.00' onChange={(e) => {
					const checker = /^[\d,]+\.?\d{0,2}?$/
					const isValid = checker.test(e.target.value);
					if(isValid) {
						this.state.deliveryDetail["unit_marketing_cost"] = e.target.value
						this.props.handler(this.state.farmerId, this.state.deliveryDetail)
						let mc = parseInt(this.state.volumeSold) * parseFloat(e.target.value)
						if(isNaN(mc)) {
							mc = 0.00
						}
						let gs = this.state.grossSales?.replace(/,/g, "")
						if(isNaN(gs)) {
							gs = 0.00
						}
						let pc = this.state.productionCost?.replace(/,/g, "")
						if(isNaN(pc)) {
							pc = 0.00
						}
						let phc = this.state.postHarvestCost?.replace(/,/g, "")
						if(isNaN(phc)) {
							phc = 0.00
						}
						const gp = gs - pc - phc
						const ni = gp - mc
						this.setState({
							mcpk: e.target.value,
							marketingCost: formatCurrency(mc),
							grossProfit: formatCurrency(gp),
							netIncome: formatCurrency(ni)
						})
					}
					else {
						if(isNaN(parseInt(e.target.value))) {
							this.setState({mcpk: null})
							e.target.value = ""
						}
						else {
							e.target.value = parseInt(e.target.value);
						}
					}
				}} />
			</div>
			<div className="cm-marketing-cost">
				<input type="text" value={this.state.marketingCost} placeholder='0.00' disabled={this.state.disabled} />
			</div>
			<div className="cm-net-income">
				<input type="text" value={this.state.netIncome} placeholder='0.00' disabled={this.state.disabled} />
			</div>
			<div className="cm-traders">
				<input type="text" value={this.state.tradersPrice} placeholder='0.00' onChange={(e) => {
					const checker = /^[\d,]+\.?\d{0,2}?$/
					const isValid = checker.test(e.target.value);
					if(isValid) {
						this.state.deliveryDetail["trader_offered_price"] = e.target.value
						this.props.handler(this.state.farmerId, this.state.deliveryDetail)
						this.setState({tradersPrice: e.target.value})
					}
					else {
						if(isNaN(parseInt(e.target.value))) {
							this.setState({tradersPrice: null})
							e.target.value = ""
						}
						else {
							e.target.value = parseInt(e.target.value);
						}
					}
				}} />
			</div>
			<div className="cm-remarks">
				<input type="text" value={this.state.remarks} onChange={(e) => {
					this.state.deliveryDetail["remarks"] = e.target.value
					this.props.handler(this.state.farmerId, this.state.deliveryDetail)
					this.setState({remarks: e.target.value})
				}} />
			</div>
		</div>
		return(view)
	}
}

const formatCurrency = (value) => {
	if(value == null || value == 0) {
		return null
	}
	const n = value.toFixed(2) + ""
	const v = n.replace(/,/g, "")
	const c = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
	return(c)
}

export default CollectiveMarketing
